import React from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../Utils/constant";

const FRAUD_MESSAGE_SUFFIX = ` for loan payments. Do not make direct bank payments to fake UPI links or unauthorised payment links. ${APP_NAME} is not responsible for payments made to other accounts.`;

const MarqueeText = ({ hidden = false }) => (
  <span
    className="fraud-marquee-bar__text"
    aria-hidden={hidden || undefined}
  >
    <strong className="fraud-marquee-bar__label">Beware of fraud!</strong>
    {" Always use our secure "}
    <Link to="/repayloan" className="fraud-marquee-bar__link">
      Repayment on Website Link
    </Link>
    {FRAUD_MESSAGE_SUFFIX}
  </span>
);

const FraudMarqueeBar = () => {
  return (
    <div
      className="fraud-marquee-bar"
      role="region"
      aria-label="Fraud prevention notice"
    >
      <div className="fraud-marquee-bar__track">
        <MarqueeText />
        <MarqueeText hidden />
      </div>
    </div>
  );
};

export default FraudMarqueeBar;
